import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private requestCount = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.loadingSubject.asObservable();
  private showTimeout: any;
  private readonly delay = 150;
  private minDisplayTime = 300;
  private showTime = 0;

  show() {
    this.requestCount++;

    // chỉ set timeout khi request đầu tiên
    if (this.requestCount === 1) {
      this.showTimeout = setTimeout(() => {
        if (this.requestCount > 0) {
          this.showTime = Date.now();
          this.loadingSubject.next(true);
        }
      }, this.delay);
    }
  }

  hide() {
    this.requestCount = Math.max(0, this.requestCount - 1);
    if (this.requestCount === 0) {
      const elapsed = Date.now() - this.showTime;
      const remaining = this.minDisplayTime - elapsed;
      if (remaining > 0) {
        setTimeout(() => this.loadingSubject.next(false), remaining);
      } else {
        this.loadingSubject.next(false);
      }
    }
  }

  reset() {
    this.requestCount = 0;
    if (this.showTimeout) {
      clearTimeout(this.showTimeout);
      this.showTimeout = null;
    }
    this.loadingSubject.next(false);
  }
}
